import { NavLink, Outlet } from 'react-router'
import { cn } from '@/lib/utils'
import { PostHogPageView } from '@/feature/posthog/page-view'

export const RootLayout = () => (
  <>
    <nav className='fixed left-0 top-0 z-10 flex min-h-14 w-full border bg-white p-4'>
      <NavLink to='/' className={({ isActive }) => cn(isActive ? `text-blue-400` : `text-stone-700`, `hover:text-blue-400 hover:underline`)}>
        Home
      </NavLink>
    </nav>
    <div className='pt-14'>
      <Outlet />
    </div>
    <PostHogPageView />
  </>
)
